<div
  class="resume-minimal"
  [style.--themeColor]="color"
  [style.font-family]="font"
>
  <div class="top-header" [ngClass]="{ 'no-image': !data.config.photoUrl }">
    <div class="top-row">
      <div class="sidebar mb-2" *ngIf="data?.config?.photoUrl">
        <img [src]="data.config.photoUrl" alt="profile" crossorigin="anonymous" />
      </div>

      <div class="title-box">
        <h1 *ngIf="data?.personal_info?.fullName">
          {{ data.personal_info.fullName }}
        </h1>

        <p class="role me-4" *ngIf="data?.targetRole">
          {{ data.targetRole }}
        </p>
      </div>
    </div>

    <div
      class="contact"
      *ngIf="
        data?.personal_info?.email ||
        data?.personal_info?.phone ||
        data?.personal_info?.location ||
        data?.personal_info?.linkedinUrl ||
        data?.personal_info?.githubUrl
      "
    >
      <span *ngIf="data?.personal_info?.email">
        <i class="bi bi-envelope-fill"></i>
        {{ data.personal_info.email }}
      </span>

      <span *ngIf="data?.personal_info?.phone">
        <i class="bi bi-telephone-fill"></i>
        {{ data.personal_info.phone }}
      </span>

      <span *ngIf="data?.personal_info?.location">
        <i class="bi bi-geo-alt-fill"></i>
        {{ data.personal_info.location }}
      </span>

      <span *ngIf="data?.personal_info?.linkedinUrl">
        <i class="bi bi-linkedin"></i>
        {{ data.personal_info.linkedinUrl }}
      </span>

      <span *ngIf="data?.personal_info?.githubUrl">
        <i class="bi bi-github"></i>
        {{ data.personal_info.githubUrl }}
      </span>
    </div>
  </div>

  <div class="section summary-box" *ngIf="data?.summary">
    <h3>SUMMARY</h3>
    <p>{{ data.summary }}</p>
  </div>

  <div class="section" *ngIf="data?.education?.length">
    <h3>EDUCATION</h3>

    <ng-container *ngFor="let e of data.education">
      <div
        class="item"
        *ngIf="e?.degree || e?.collegeName || e?.startYear || e?.endYear"
      >
        <div class="row-space">
          <div>
            <b class="title" *ngIf="e?.degree">{{ e.degree }}</b>

            <p class="sub" *ngIf="e?.collegeName || e?.location">
              {{ e.collegeName }}
              <span *ngIf="e?.collegeName && e?.location">, </span>
              {{ e.location }}
            </p>

            <p *ngIf="e?.cgpa_or_percentage" class="muted">
              CGPA: {{ e.cgpa_or_percentage }}
            </p>
          </div>

          <span class="date" *ngIf="e?.startYear || e?.endYear">
            <ng-container *ngIf="e?.startMonth || e?.startYear">
              {{ e.startMonth }} {{ e.startYear }}
            </ng-container>

            <span *ngIf="e?.startYear && e?.endYear"> - </span>

            <ng-container *ngIf="e?.endMonth || e?.endYear">
              {{ e.endMonth }} {{ e.endYear }}
            </ng-container>
          </span>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.projects?.length">
    <h3>PROJECTS</h3>

    <ng-container *ngFor="let p of data.projects">
      <div class="item" *ngIf="p?.title || p?.description">
        <b class="title" *ngIf="p?.title">{{ p.title }}</b>

        <p class="muted" *ngIf="p?.technologies?.length">
          {{ p.technologies.join(" • ") }}
        </p>

        <p class="desc" *ngIf="p?.description">{{ p.description }}</p>

        <p *ngIf="p?.outcome" class="highlight">↗ {{ p.outcome }}</p>
      </div>
    </ng-container>
  </div>

  <div
    class="section"
    *ngIf="
      data?.skills?.technicalSkills?.length ||
      data?.skills?.tools?.length ||
      data?.skills?.softSkills?.length
    "
  >
    <h3>SKILLS</h3>

    <p *ngIf="data?.skills?.technicalSkills?.length">
      <b>Technical:</b>
      {{ data.skills.technicalSkills.join(" • ") }}
    </p>

    <p *ngIf="data?.skills?.tools?.length">
      <b>Tools:</b>
      {{ data.skills.tools.join(" • ") }}
    </p>

    <p *ngIf="data?.skills?.softSkills?.length">
      <b>Soft Skills:</b>
      {{ data.skills.softSkills.join(" • ") }}
    </p>
  </div>

  <div class="section" *ngIf="data?.experience?.length">
    <h3>EXPERIENCE</h3>

    <ng-container *ngFor="let e of data.experience">
      <div class="item" *ngIf="e?.role || e?.company">
        <div class="row-space">
          <b class="title" *ngIf="e?.role">{{ e.role }}</b>

          <span
            class="date"
            *ngIf="e?.startYear || e?.endYear || e?.currently_working"
          >
            <ng-container *ngIf="e?.startMonth || e?.startYear">
              {{ e.startMonth }} {{ e.startYear }}
            </ng-container>

            <span *ngIf="e?.startYear && (e?.endYear || e?.currently_working)">
              -
            </span>

            <ng-container *ngIf="e?.currently_working"> Present </ng-container>

            <ng-container *ngIf="!e?.currently_working">
              {{ e.endMonth }} {{ e.endYear }}
            </ng-container>
          </span>
        </div>

        <p class="sub" *ngIf="e?.company || e?.location">
          {{ e.company }}
          <span *ngIf="e?.company && e?.location">, </span>
          {{ e.location }}
        </p>

        <p class="desc" *ngIf="e?.description">
          {{ e.description }}
        </p>
      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.certifications?.length">
    <h3>CERTIFICATIONS</h3>

    <ng-container *ngFor="let c of data.extras.certifications">
      <p *ngIf="c?.name || c?.platform || c?.year">
        <span *ngIf="c?.name">• {{ c.name }}</span>

        <span *ngIf="c?.platform || c?.year">
          <span *ngIf="c?.name"> - </span>
          {{ c.platform }}
          <span *ngIf="c?.platform && c?.year"> (</span>
          {{ c.year }}
          <span *ngIf="c?.platform && c?.year">)</span>
        </span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.awards?.length">
    <h3>AWARDS</h3>

    <ng-container *ngFor="let a of data.extras.awards">
      <p *ngIf="a?.name || a?.organization">
        <span *ngIf="a?.name">• {{ a.name }}</span>

        <span *ngIf="a?.organization"> ({{ a.organization }}) </span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.hackathons?.length">
    <h3>HACKATHONS</h3>

    <ng-container *ngFor="let h of data.extras.hackathons">
      <p *ngIf="h?.name || h?.rank">
        <span *ngIf="h?.name">• {{ h.name }}</span>
        <span *ngIf="h?.rank">({{ h.rank }})</span>
      </p>
    </ng-container>
  </div>

  <div class="section mb-5" *ngIf="data?.extras?.languages?.length">
    <h3>LANGUAGES</h3>

    <ng-container *ngFor="let l of data.extras.languages">
      <p *ngIf="l?.name">
        <span *ngIf="l?.name">• {{ l.name }}</span>
        <span *ngIf="l?.proficiency"> ({{ l.proficiency }}) </span>
      </p>
    </ng-container>
  </div>
</div>
